// extracted by mini-css-extract-plugin
export var backdropBlur = "_hh-0";
export var contentCard = "_hh-5";
export var frame = "_hh-2";
export var image = "_hh-4";
export var imagePane = "_hh-3";
export var modal = "_hh-1";